var Vue = require('vue')
var api = require('api')

var local = require('./local')

module.exports = {
  login: function (store, auth, next) {
    local.put('client.logged', true)
    local.put('client.auth', auth)
    var self = this

    // clear warnings
    local.clearWarnings()

    Vue.http.headers.common['Authorization'] =
      auth.token_type + ' ' + auth.access_token

    api.User.profile({
      username: auth.username
    }).then(function (result) {
      local.put('client.user', result.data) // result.data[0])
      store.dispatch('LOGIN', auth, result.data) // result.data[0])
      var langCode = local.get('client.language')
      if (result.data.langCode === langCode) {
        next(null, 'general.message.login')
      } else {
        // get lang
        var lang = result.data.langCode
        local.put('client.language', lang)
        self.changeLanguage(lang).then(function (data) {
          next(null, 'general.message.login')
        })
      }
    }, function (err) {
      local.clear()
      Vue.http.headers.common['Authorization'] = ''
      store.dispatch('LOGOUT')
      next(err)
    })
  },
  adminLogin: function (store, auth, next) {
    local.put('client.logged', true)
    local.put('client.auth', auth)

    Vue.http.headers.common['Authorization'] =
      auth.token_type + ' ' + auth.access_token

    api.Admin.query({
      username: auth.username
    }).then(function (result) {
      local.put('client.user', result.data)
      store.dispatch('LOGIN', auth, result.data)
      next(null, 'general.message.login')
    }, function (err) {
      local.clear()
      Vue.http.headers.common['Authorization'] = ''
      store.dispatch('LOGOUT')
      next(err)
    })
  },
  setUser: function (store, user) {
    local.put('client.user', user)
    store.dispatch('SET_USER', user)
  },
  activate: function (store) {
    store.dispatch('ACTIVATE')
  },
  deactivate: function (store) {
    store.dispatch('DEACTIVATE')
  },
  logout: function (store) {
    local.clear()
    Vue.http.headers.common['Authorization'] = ''
    store.dispatch('CLEAR')
  },
  changeLanguage: function (store, language) {
    return api.Label.get({
      lang: language,
      type: 'all'
    }).then(function (result) {
      return new Promise(function (resolve, reject) {
        var filters = require('../filters')()
        filters.updateLabels(result.data)
        console.log(language)
        local.put('client.language', language)
        store.dispatch('SET_LANGUAGE', language)
        resolve()
      })
    })
  },
  reloadUser: function (store) {
    const logged = local.get('client.logged')
    if (!logged) return undefined

    let self = this
    let auth = local.get('client.auth')

    Vue.http.headers.common['Authorization'] =
      auth.token_type + ' ' + auth.access_token

    return api.User.profile({
      username: auth.username
    }).then(function (result) {
      self.setUser(result.data)
      // clear warnings
      local.clearWarnings()
      return Promise.resolve()
    }, function () {
      local.clear()
      Vue.http.headers.common['Authorization'] = ''
      store.dispatch('LOGOUT')
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/store/actions.js